import React from "react";
import { Input, Spacer } from '@nextui-org/react';

const OrderAndLocation = ({
  setOrderAndLocationToState,
  orderId,
  customerShipmentId,
  stopSeq,
  stopDate,
  appointmentTime1,
  appointmentTime2,
  stopId,
  stopName,
  locationContactName,
  locationContactNumber,
  carrierName,
  billTo,
  address,
  city,
  state,
  zip
}) => {
  const inputStyles = {
    css: { 
      $$inputBorderRadius: "0.375rem", 
      flexGrow: 1, 
      h: 40, 
      mt: 2,
      backgroundColor: "white",
      "&:hover": {
        borderColor: "hsl(var(--p))"
      }
    },
    shadow: false,
    bordered: true,
    rounded: true,
    classNames: {
      input: "text-sm",
      label: "text-sm font-medium text-gray-700"
    }
  };

  const labelStyles = "text-sm font-medium text-gray-700 mb-1";
  const gridStyles = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-base-100 rounded-lg shadow-sm";

  const renderInput = (label, type, placeholder, value, field) => (
    <div className="form-control w-full">
      <label className={labelStyles}>{label}</label>
      <Input
        type={type}
        placeholder={placeholder}
        clearable
        onChange={(e) => setOrderAndLocationToState("orderAndLocationDetails", field, e.target.value)}
        value={value}
        {...inputStyles}
      />
    </div>
  );

  const renderFirstRow = () => (
    <div className={gridStyles}>
      {renderInput("Order Number", "text", "Enter Order ID", orderId, "orderId")}
      {renderInput("Customer Shipment ID", "text", "Enter Customer Shipment ID", customerShipmentId, "customerShipmentId")}
      {renderInput("Stop Sequence", "number", "Enter Stop Sequence", stopSeq, "stopSeq")}
      {renderInput("Stop Date", "date", "", stopDate, "stopDate")}
    </div>
  );

  const renderSecondRow = () => (
    <div className={gridStyles}>
      {renderInput("Appointment Time 1", "time", "", appointmentTime1, "appointmentTime1")}
      {renderInput("Appointment Time 2", "time", "", appointmentTime2, "appointmentTime2")}
      {renderInput("Stop ID", "text", "Enter Stop ID", stopId, "stopId")}
      {renderInput("Stop Name", "text", "Enter Stop Name", stopName, "stopName")}
    </div>
  );

  const renderThirdRow = () => (
    <div className={gridStyles}>
      {renderInput("Location Contact Name", "text", "Enter Location Contact Name", locationContactName, "locationContactName")}
      {renderInput("Location Contact No.", "text", "Enter Location Contact Number", locationContactNumber, "locationContactNumber")}
      {renderInput("Carrier Name", "text", "Enter Carrier Name", carrierName, "carrierName")}
      {renderInput("Bill To", "text", "Enter Bill To", billTo, "billTo")}
    </div>
  );

  const renderFourthRow = () => (
    <div className={gridStyles}>
      <div className="col-span-1 md:col-span-2 lg:col-span-3">
        {renderInput("Address", "text", "Enter Address", address, "address")}
      </div>
      <div>
        {renderInput("City", "text", "Enter City", city, "city")}
      </div>
    </div>
  );

  const renderFifthRow = () => (
    <div className={gridStyles}>
      {renderInput("State", "text", "Enter State", state, "state")}
      {renderInput("ZIP", "text", "Enter Zip Code", zip, "zip")}
    </div>
  );

  return (
    <div className="space-y-4 p-4 bg-base-200 rounded-xl">
      {renderFirstRow()}
      {renderSecondRow()}
      {renderThirdRow()}
      {renderFourthRow()}
      {renderFifthRow()}
    </div>
  );
};

export default OrderAndLocation;